import React, { useState } from 'react';
import Button from '../ui/Button';
import { toast } from 'react-toastify';

function DeleteConfirmationModal({ method, itemId, onClose, onConfirm }) {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleDelete = async () => {

    try {
        await method(itemId);
        toast.success('Deleted successfully!');
        onClose(); // Close the modal after successful deletion
        onConfirm(); // Optionally call onConfirm if you need to perform additional actions
        // navigate('/issues'); // Redirect to the issues list page
    } catch (err) {
        toast.error(err.message || 'Failed to delete');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-white dark:bg-gray-900 p-6 rounded-lg">
        <h2 className="text-xl font-bold mb-4">Confirm Deletion</h2>
        <p className="mb-4">Are you sure you want to delete this item? This action cannot be undone.</p>
        <div className="flex justify-end space-x-2">
          <Button onClick={onClose} variant="outline">Cancel</Button>
          <Button onClick={handleDelete} variant="destructive">Delete</Button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmationModal;